module.exports = __webpack_public_path__ + "img/logo-login.10bc3caa.svg";